// @flow
import React, {Component} from 'react'
import {compose} from 'redux'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import Markdown from 'react-markdown'
import css from './index.css'
import grid from '$src/grid/grid.css'
import {parse} from 'query-string'

import amplitude from '$src/analytics/amplitude'
import GenericButton from '$common/components/GenericButton'
import Header from '$common/components/Header'
import {selectRefreshToken, selectIdToken, selectEmail} from '$src/auth/selectors'
import {type StoreState} from '$src/state/types'
import authorize from '$src/auth/sagas/authorize'
import fetchClient from '$src/client/sagas/fetchClient'
import {type ClientNamespaceState} from '$src/client/types'
import {selectClient} from '$src/client/selectors'
import {isFetching} from '$src/requests/selectors'
import {resolveCss, withTranslate, type WithTranslateProps, setTokensState} from '$util'

type Props = WithTranslateProps & {
  refreshToken: ?string,
  authorizing: boolean,
  idToken: ?string,
  email: ?string,
  history: Object,
  location: {search: string},
  client: ClientNamespaceState
}

export class Consent extends Component<Props> {

  queryParams: {scope?: string, client_id?: string} = parse(this.props.location.search)

  componentWillMount() {
    if (this.queryParams.client_id) {
      this.context.runSaga(fetchClient, this.queryParams.client_id)
    }
  }

  authorize = () => {
    amplitude.logEvent('[UI] Consent::accept', this.props.client)
    this.context
      .runSaga(authorize, this.props.history.location.search)
      .then((res: {data: {url: string}}) => {
        document.location.replace(res.data.url)
      })
  }

  logout = async () => {
    amplitude.logEvent('[UI] Logout::logout', this.props.client)
    await this.context.runSaga(setTokensState)
    this.props.history.replace('/login' + this.props.history.location.search)
  }

  cancel = () => {
    amplitude.logEvent('[UI] Consent::cancel', this.props.client)
    this.context
      .runSaga(authorize, this.props.history.location.search, {allowed: false})
      .then((res: {data: {url: string}}) => {
        document.location.replace(res.data.url)
      })
  }

  render() {
    const classes = resolveCss(css, grid)
    // $FlowIgnore
    const {name: clientName} = this.props.client
    const scopes = (this.queryParams.scope || '').split(' ').map(scope => {
      return this.props.t(`scope.${scope}.list`)
    }).join('\n')
    return (
      <div {...classes('container')} data-tid='page-consent'>
        <Header />
        <div {...classes('columnLarge6', 'contentContainer')}>
          <h2 className={css.title}>{this.props.t('consent.title')}</h2>
          <p>{this.props.t('consent.body', {thirdparty: clientName})}</p>
          {this.queryParams.scope && (
            <Markdown className={css.scopeList} source={scopes} />
          )}
        </div>
        <div {...classes('buttonsContainer')}>
          <GenericButton
            style="outline"
            css={{container: css.cancel}}
            loading={this.props.authorizing}
            onClick={this.cancel}
            data-tid='consent-cancel'
          >
            {this.props.t('common.cancel')}
          </GenericButton>
          <GenericButton
            style="bold"
            css={{container: css.accept}}
            loading={this.props.authorizing}
            onClick={this.authorize}
            data-tid='consent-submit'
          >
            {this.props.t('common.accept')}
          </GenericButton>
        </div>
        <p {...classes('email')}>{this.props.email}</p>
        <GenericButton
          style="subtle"
          onClick={this.logout}
          data-tid='logout'
        >
          {this.props.t('consent.changeUser')}
        </GenericButton>
      </div>
    )
  }
}

Consent.contextTypes = {
  runSaga: PropTypes.any,
}

export default compose(
  withTranslate(),
  connect((state: StoreState) => ({
    refreshToken: selectRefreshToken(state),
    client: selectClient(state),
    authorizing: isFetching(state, 'authorize'),
    idToken: selectIdToken(state),
    email: selectEmail(state),
  }))
)(Consent)



// WEBPACK FOOTER //
// ./src/consent/components/Consent/index.js